<template>
  <div class="">
    <div class="agreement-header">
      <h2 class="title white" style="text-align: center;">Seu convênio é</h2>
      <img :src="$baseUrl + 'storage/' + agreement.image" alt="">
      <div class="btn" style="margin-top: 14px; margin-left: 20px; padding: 0 10px; font-size: 22px;"
      @click=" changeAgreement()">
        <span>Trocar convênio</span>
      </div>
    </div>
    <h2 class="title white" style="margin-top: 0px; font-size: 32px;">Selecione o Médico</h2>
    <div class="ui five column grid" style="width: 1300px; margin: 0 auto;">

      <div v-show="is_loading || isLoadingAgreement" style="margin: 0 auto;">
        <h2  style="color: #fff;">Carregando sugestões...</h2>
        <pulse-loader :loading="loading" :color="color" :size="size" style="width: fit-content; margin: 0 auto;"></pulse-loader>
      </div>
      <paginate
        v-show="!is_loading"
        name="agreementProfs"
        :list="agreementProfs"
        :per="10"
        style="border: 1px solid; display: contents;"
      >
        <div v-for="professional in paginated('agreementProfs')" :key="professional.id" class="column" style="margin: 0px 20px;">
          <div v-show ="professional.image != null" class="option" @click="selectProfessional(professional)">
            <img :src="$baseUrl + '/storage/' + professional.image" alt="">
            <div class="prof-data">
              <span>{{ professional.name }}</span>
              <span>CRM-{{ professional.council_state }} {{ professional.council_number }}</span>
            </div>
          </div>
          <div v-show="professional.image == null" class="option" style="width: 220px;">
            <img :src="'/static/img/profile-icon.png'" alt="">
            <div class="prof-data">
              <span>{{ professional.name }}</span>
              <span>CRM-{{ professional.council_state }} {{ professional.council_number }}</span>
            </div>
          </div>
        </div>
      </paginate>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
      <paginate-links
        for="agreementProfs"
        :simple="{
          prev: 'Voltar',
          next: 'Outros médicos'
        }"
      ></paginate-links>
    </div>
  </div>
</template>
<script>
import MoonLoader from 'vue-spinner/src/MoonLoader';
import PulseLoader from 'vue-spinner/src/PulseLoader';
export default {
  components: {
      MoonLoader,
      PulseLoader
  },
  props: {
      agreement: Object,
      agreementProfs: Array,
      ticket: Object,
      isLoadingAgreement: Boolean
  },
  data() {
    return {
      is_loading: false,
      loading: false,
      color: '#fff',
      width: '50',
      height: '50',
      size: '20px',
      msg: 'Por favor, escolha um médico',
      lang: 'pt-BR',
      arrPaginate: [],
      page: 1,
      limit: 10,
      countPage: 0,
      paginate: ['agreementProfs']
    }
  },
  created() {

  },
  mounted() {
    var app = this;
    this.speak(this.msg);
    setTimeout(function() {
      app.countPage = Math.ceil(app.agreementProfs.length / app.limit);
      console.log('count page:', app.countPage);
      app.paginated(app.agreementProfs);
    }, 300);
  },
  methods: {
    changeAgreement(){

      this.$emit('buttonClicked', 'AgreementsList');
    },
    speak(msg) {
      var app = this;
      var utterThis = new SpeechSynthesisUtterance(msg);
      var voices = speechSynthesis.getVoices();
      var voice_br = {};
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      window.speechSynthesis.speak(utterThis);
    },
    falar() {
      let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
      let recognition = SpeechRecognition ? new SpeechRecognition() : false
      recognition.lang = this.lang;
      recognition.interimResults = true;
    },
    selectProfessional(prof) {
      this.is_loading = true;
      this.loading = true;
      this.$emit('setProfessional', prof);
    }
  }
}
</script>
<style scoped>

.agreement-header {
  display: flex;
  margin: 0 auto;
  width: fit-content;
}
.agreement-header h2 {
  text-align: center;
  font-size: 32px;
  line-height: 90px;
  padding-right: 20px;
}
.agreement-header img {
  width: 90px;
  height: 90px;
  border-radius: 500px;
}
h2 {
  font-size: 42px;
  font-weight: bold;
  font-family: 'Source Sans Light';
}
.column {
  height: 332px;
  padding-top: 52px;
}
.option {
  /* height: 220px; */
  height: 182px;
  margin: 0 auto;
  padding-top: 10px;
  text-align: center;
  background: #56ccf2;
  border-radius: 20px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.option img {
  /* width: 180px;
  height: 180px; */
  width: 120px;
  height: 120px;
  margin: 0 20px;
  margin-top: -60px;
  background: #fff;
  border-radius: 500px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 1px 2px rgba(0,0,0,0.23);
}
.option span {
  position: absolute;
  bottom: 100px;
  left: 50px;
  width: 200px;
  font-size: 20px;
  color: #fff;
  line-height: 33px;
  border: 1px solid;
}
.prof-data {
  display: grid;
  width: 100%;
  height: 80px;
  padding: 0 10px;
}
.prof-data span {
  position: inherit;
  bottom: 60px;
  font-size: 16px;
  line-height: 18px;
  font-weight: bold;
  border: none;
}
.footer-btn {
  position: fixed;
  width: 100%;
  display: flex;
  bottom: 16px;
  padding: 0px 20px;
}
.btn {
  display: flex;
  width: 180px;
  height: 60px;
  align-items: center;
  font-size: 26px;
  border-radius: 500px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.btn span {
  width: inherit;
}
.pagination {
  position: absolute;
  display: flex;
  width: fit-content;
  right: 40px;
}
.pagination .btn {
  width: fit-content;
  min-width: 180px;
  text-align: center;
  margin: 0 4px;
  padding: 0 20px;
}
.pagination .btn span {
  min-width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfessionalsList.vue